(function () {
    'use strict';

    angular.module('table')
        .controller('TableController', [
            '$rootScope',
            '$scope',
            '$location',
            'editService',
            'ArcGISMap',
            'DataService',
            'NotesService',
            'tableConfigService',
            'FilterService',
            'GalleryService',
            'DocumentService',
            'dialogService',
            'dataConfigService',
            'SharedState',
            '$routeParams',
            'keycloakService',
            function ($rootScope, $scope, $location, editService, ArcGISMap, DataService, NotesService, tableConfigService,
                      FilterService, GalleryService, DocumentService, dialogService, dataConfigService, SharedState, $routeParams, keycloakService) {
                $scope.tableConfig = tableConfigService;
                $scope.data = DataService.getData();
                $scope.dataConfig = dataConfigService.config;
                $scope.maxResult = 50;
                var oldSearchString = '';

                var openedId = $routeParams.id;
                if (openedId) {
                    keycloakService.getInitPromise().then(function(result) {
                        editService.getObjectById(openedId).then(function(response) {
                            if (response) {
                                editService.obj = response.data;
                                SharedState.turnOn('edit');
                            }
                        });
                        return result
                    });
                }

                $scope.editService = editService;
                $scope.notesService = NotesService;

                $rootScope.$on('reloadTable', function () {
                    $scope.data = DataService.getData();
                    $scope.maxResult = 50;
                });

                $scope.$on('newSearchString', function($event, newSearchString) {
                    if (newSearchString && newSearchString.length == 1 && oldSearchString.length < 1) {
                      for (var i = 0; i < $scope.data.length; i++) {
                        if ($scope.data[i].selectedRec) {
                            $scope.data[i].selectedRec = false;
                        }
                      }
                    }
                    oldSearchString = newSearchString;
                    $scope.searchString = newSearchString;
                });

                $scope.$emit('searchStringRequest');

                $scope.search = function(element) {
                    return DataService.filterData(element, $scope.searchString);
                };

                $scope.setOrder = function (config) {
                    if (config.order == '') {
                        config.order = '+';
                    } else if (config.order == '+') {
                        config.order = '-'
                    } else if (config.order == '-') {
                        config.order = ''
                    }

                    $scope.$emit('redrawTable');
                };

                $scope.getOrder = dataConfigService.getOrder;

                $scope.openGallery = function (item) {
                    GalleryService.setCurrentObject(item);
                }

                $scope.openDocuments = function (item) {
                    DocumentService.setCurrentObject(item);
                    $scope.$emit('openDocuments');
                }

                $scope.showNotes = function (obj) {
                    $scope.notesService.resetNotes();
                    $scope.notesService.obj = obj;
                    $scope.notesService.loadNotes();
                };

                $scope.showEdit = function (editableObject, editableField) {
                    var data = angular.copy(editableObject);
                    editService.updateStatus(data).then(function(response){
                        DataService.refreshData(FilterService.filters);
                        response.data.focus = editableField;
                        editService.obj = response.data;
                        SharedState.turnOn('edit');
                    });
                };

                $scope.clone = function (clonableObject) {
                    $scope.editService.obj = angular.copy(clonableObject);
                    $scope.editService.obj.id = null;
                };

                $scope.markOnMap = function (item) {
                    if (item.xnuo && item.ynuo) {
                        ArcGISMap.zoomToPoint(item);
                        $location.path('/map');
                    } else {
                        alert('Kelių priežiūros objektui nenurodytos pradžios koordinatės');
                    }
                };

                $scope.bottomReached = function () {
                    $scope.maxResult += 50;
                };

                $scope.remove = function (id) {
                    dialogService.confirm('', 'Ar tikrai norite panaikinti kelių priežiūros objektą?', 'trinti').then(function () {
                        $scope.editService.remove(id).success(function () {
                            DataService.refreshData(FilterService.filters);
                        }).error(function (data, status) {
                            dialogService.error(status === 403 ? 'Nepakanka teisių' : 'Įvyko klaida trinant objektą');
                        });
                    });
                };

                function getDays(timeLeft) {
                    return Math.floor(timeLeft / (24 * 60 * 60 * 1000));
                }

                $scope.isCheckTime = function (item) {
                    if (_.includes(tableConfigService.normalRow, item.defektoStatusasLowValue)) {
                        return 'normal';
                    }
                    if (item.sprendimoData != null) {
                        var timeNow = new Date().getTime();
                        var timeLeft = new Date(item.sprendimoData) - timeNow;
                        var timeInDays = getDays(timeLeft);
                        if (timeInDays <= 7 && timeInDays > 1) return 'warn';
                        else if (timeInDays < 2) return 'critical';
                        else return 'normal';
                    }
                    else return 'normal';
                };
            }
        ]);
})();
